import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileService } from './user-profile.service';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
    public modalOpen: boolean;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    saveImages: any;
    ImageCroppedEvent: any;
    @Input()
    Image;

    @Output()
    child =  new EventEmitter();



  constructor(
    public activeModal: NgbActiveModal,
    private _userProfileService: UserProfileService,
  ) { }

  ngOnInit() {

    this._userProfileService.modal.subscribe(isOpen => {
        console.log('i received to open modal ?', isOpen);
        this.modalOpen = isOpen as boolean;
    });
  }
  closeModal() {
    this._userProfileService.close();
    this.activeModal.dismiss();
}

fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
}

// imageCropped(event: ImageCroppedEvent) {
//     this.croppedImage = event.base64;
//     console.log(this.croppedImage);
// }
imageLoaded() {
    // show cropper
}
loadImageFailed() {
    // show message

}
saveImage() {
    this.saveImages =  this.croppedImage;
    this.child.emit(this.saveImages);
    console.log(this.child.emit(this.saveImages));
    this.activeModal.dismiss();
}
}



// WEBPACK FOOTER //
// ./src/app/user-profile/user-profile.component.ts